import { FC } from 'react';
import noop from 'lodash-es/noop';
import { TeamChatTypes } from '@frontend/api-team-chat';
import { MessageRegular } from '../../conversation/message/message-regular';

interface KeywordListItemProps {
  message: TeamChatTypes.Message;
}

export const KeywordListItem: FC<KeywordListItemProps> = ({ message }) => {
  return <MessageRegular message={message} isThread={true} onDelete={noop} isActionable={false} />;
};
